<div class="chat-wrapper" [hidden]="selectedChat()">
  <div class="search-bar">
    <input matInput placeholder="Buscar chats..." [(ngModel)]="searchTerm" (input)="filterChats()">
  </div>
  <div class="chats">
    <button mat-icon-button class="archived" (click)="toggleArchived()">
      <div class="unread" *ngIf="unreadArchived > 0">{{unreadArchived}}</div>
      <mat-icon *ngIf="showArchived" matTooltip="Ocultar completados">visibility_off</mat-icon>
      <mat-icon *ngIf="!showArchived" matTooltip="Mostrar completados">visibility</mat-icon>
    </button>
    @if(chats.length == 0 || loading()){
      <div class="no-chats">
        @if(!loading()){
          <p>No hay chats aun</p>
          ¡Agrega uno desde ordenes de trabajo!
        }@else{
          <mat-spinner style="margin-bottom: 10px"></mat-spinner>
          <p>Cargando chats...</p>
        }
      </div>
    } @else {
      <mat-tab-group [class.searching]="searching()">
        <mat-tab *ngFor="let type of documentTypes">
          <ng-template mat-tab-label>
            <mat-icon *ngIf="type.icon" [matTooltip]="type.name | human">{{ type.icon }}</mat-icon>
            <span *ngIf="getMentionCountByType(type) > 0" class="mention-count">
              ({{ getMentionCountByType(type) }})
            </span>
            <div *ngIf="hasUnreadByType(type)" class="unread tab">
              
            </div>
          </ng-template>
          <div *ngIf="filteredChatsByType(type).length === 0" class="no-chats">
            <p>No hay chats de {{type.name | human}}</p>
          </div>
          <div class="chat" *ngFor="let chat of filteredChatsByType(type)" (click)="openChat(chat)" [class.has-work]="chat.works?.length > 0" [hidden]="!showArchived && !chat.listed">
            <div class="chat-image">
              <div class="chat-image-container" style="background-image: url('{{ chat.picture | thumbnail }}')">
                <span *ngIf="chat.works?.length > 0" class="icon-work">
                  <mat-icon>build</mat-icon>
                </span>
                <span *ngIf="!chat.listed" class="icon-finished">
                  <mat-icon>check</mat-icon>
                </span>
              </div>
            </div>
            <div class="chat-content">
              <div class="chat-header">
                <div class="chat-title">
                  <app-chat-document-chip [chat]="chat"></app-chat-document-chip>
                  <div class="chat-subtitle">
                    {{chat.subtitle}}
                  </div>
                  <h4>{{chat.title}} <i class="identifier">#{{chat.correlative_id}}</i></h4>
                </div>
                <div class="chat-info">
                  <span class="chat-time" [class.unreaded]="chat.unread > 0">
                    {{ isToday(chat.last_comment?.created_at) ? (chat.last_comment?.created_at | date:'shortTime') : (chat.last_comment?.created_at | date:'shortDate') }}
                  </span>
                  <div class="chat-icons">
                    @if(chat.mention > 0){
                      <div class="mention-count">
                        &#64;
                      </div>
                    }
                    <div class="mention-count" *ngIf="chat.mention > 0">{{chat.mention}}</div>
                    <div class="unread-count" *ngIf="chat.mention === 0 && chat.unread > 0"></div>
                    @if(chat.works?.length > 0){
                      <div class="work-icon">
                        <mat-icon>build</mat-icon>
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="chat-body" *ngIf="chat.last_comment">
                <div>
                  <strong *ngIf="chat.last_comment?.author?.name" style="margin-right: 2px;">{{chat.last_comment?.author?.name?.split(" ")[0]}}:</strong>
                  <div class="message-content" [class.unreaded]="chat.unread > 0">{{chat.last_comment | message:true:40}}</div>
                </div>
              </div>
              <div class="chat-footer">
                @if(chat.works?.length > 0){
                  @for(work of chat.works; track work.id){
                    <div class="at-work">
                      {{work.work?.name || 'Otros'}}
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    }
  </div>
  <div class="user-details">
    <app-chat-user [user]="user" [showMenu]="true"></app-chat-user>
    <div class="user-name">
      <h4>{{ user.name }}</h4>
      <i>{{ user.role.name || 'Puesto' }}</i>
    </div>
    <div class="expander"></div>
    <div class="user-actions">
      <button mat-icon-button (click)="toggleIA()">
        @if(loadingIA()){
          <mat-icon>
            <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
          </mat-icon>
        }@else{
          <mat-icon>assistant</mat-icon>
        }
      </button>
      <button mat-icon-button (click)="openProfile()">
        <mat-icon>settings</mat-icon>
      </button>
      
    </div>
  </div>
</div>
<app-chat-detail *ngIf="selectedChat()" [chat]="selectedChat" (closed)="goBack()" (updateWorks)="getChats()"></app-chat-detail>

